@if (current(); as current) {
  <div class="tw-fixed tw-inset-0 tw-z-[60] tw-flex tw-items-center tw-justify-center tw-p-4"
    role="alertdialog" aria-modal="true">
    <div class="tw-fixed tw-inset-0 tw-bg-black/40" (click)="answer(false)"></div>
    <div class="tw-relative tw-bg-base-100 tw-rounded-lg tw-shadow-xl tw-w-full tw-max-w-sm tw-p-5">
      <div class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-text-warning tw-text-2xl tw-shrink-0" aria-hidden="true">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <p class="tw-text-sm tw-text-oab-ink tw-m-0" [innerHTML]="current.message"></p>
      </div>
      <div class="tw-flex tw-justify-end tw-gap-2 tw-mt-5">
        <button type="button" class="tw-btn tw-btn-ghost tw-btn-sm" (click)="answer(false)">
          {{ current.cancelText }}
        </button>
        <button type="button" class="tw-btn tw-btn-primary tw-btn-sm" (click)="answer(true)">
          {{ current.confirmText }}
        </button>
      </div>
    </div>
  </div>
}
